function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.14038 7.07812C6.42664 7.07812 4.21826 9.2865 4.21826 12.0002C4.21826 14.714 6.42664 16.9224 9.14038 16.9224C11.8541 16.9224 14.0625 14.714 14.0625 12.0002C14.0625 9.2865 11.8541 7.07812 9.14038 7.07812ZM12.4501 11.0905L8.93419 14.6064C8.79705 14.7436 8.6167 14.8126 8.43728 14.8126C8.2574 14.8126 8.07752 14.744 7.94038 14.6064L5.8311 12.4972C5.55634 12.2224 5.55634 11.7776 5.8311 11.5029C6.10585 11.2281 6.55063 11.2281 6.82539 11.5029L8.43775 13.1152L11.4563 10.0967C11.7311 9.82193 12.1758 9.82193 12.4506 10.0967C12.7249 10.371 12.7249 10.8162 12.4501 11.0905Z",
  fill: "#469650"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.5782 2.85922H15.9311C13.5537 2.85922 11.319 1.88654 9.63804 0.206067C9.36329 -0.0686888 8.91851 -0.0686888 8.64376 0.206067C6.96282 1.88701 4.72767 2.85922 2.35068 2.85922H0.703092C0.314207 2.85922 0 3.17342 0 3.56231V11.9999C0 18.3183 4.59757 21.2575 7.64008 23.1709C7.91812 23.3456 8.84431 23.9999 9.14067 23.9999C9.43609 23.9999 10.3378 23.3621 10.615 23.1883C13.6678 21.2735 18.2813 18.3315 18.2813 11.9999V3.56231C18.2813 3.17342 17.9667 2.85922 17.5782 2.85922ZM9.14067 18.3282C5.65104 18.3282 2.81237 15.4895 2.81237 11.9999C2.81237 8.51025 5.65104 5.67159 9.14067 5.67159C12.6303 5.67159 15.469 8.51025 15.469 11.9999C15.469 15.4895 12.6303 18.3282 9.14067 18.3282Z",
  fill: "#469650"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18.2813,
  height: 24,
  fill: "white"
})));

const SvgSafeSecureIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 24,
  viewBox: "0 0 19 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSafeSecureIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/safe-secure-icon.df8b7293.svg";
export { ForwardRef as ReactComponent };